import { render, staticRenderFns } from "./importOutlets.vue?vue&type=template&id=3f5cf6f4&"
import script from "./importOutlets.vue?vue&type=script&lang=js&"
export * from "./importOutlets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports